import { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useParams } from 'react-router';
import { ensureKnown } from '../../store/knownDataSlice';
import QueryDetails from '../parts/QueryDetails';



function QueryView(props) {
    const id = useParams()["id"].toUpperCase();
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(ensureKnown({ id }));
    }, []);

    const data = useSelector((state) => state.knownData[id]);

    if(!data) return;

    return (
        <div className="column g32 p32 screen center-cross">

            <div className="column g32" style={{ maxWidth: '100%' }}>

                <div className="column g8">
                    <div className="row g16 center-cross">
                        <h1>Päring</h1>
                        <p>(vastamata)</p>
                    </div>
                    <h2>{JSON.parse(data["query_route"]).map(route => route["city_name"]).join(" - ")}</h2>
                </div>

                <QueryDetails id={id} />

            </div>

        </div>
    );
};

export default QueryView;